import { createContext } from 'react';

const DetalleComisionesContext = createContext();

export default DetalleComisionesContext;
